import { CONSENT_CHANGED_EVENT } from './changeEvents'
import { useEffect, useState } from 'react'
import { isConsentRequiredOnClient } from './clientScope'
import { readConsentState } from './deviceState'

export function useCookieSettingsLinkVisible() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const update = () => setIsVisible(isConsentRequiredOnClient() && !!readConsentState())
    update()
    window.addEventListener(CONSENT_CHANGED_EVENT, update)
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, update)
  }, [])

  return isVisible
}
